
































import { Component, p, Prop } from "av-ts";
import BaseComponent from "../BaseComponent";

@Component({name: 'Handle'})
export default class Handle extends BaseComponent {
    @Prop handleSize = p({
        type: Number,
        default: 9,
    })
}
